import { Modal, Table } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { MdOutlineMessage } from 'react-icons/md';
import { RepayemtRemark } from '../../Investments/redux/types';

type Props = {
    list: RepayemtRemark[];
};

const RemarksModal: React.FC<Props> = ({ list }) => {
    const [open, setOpen] = useState(false);

    const onClickCancel = () => {
        setOpen(false);
    };

    const onClickRemark = () => {
        setOpen(true);
    };

    const columns = [
        {
            title: 'Time',
            dataIndex: '',
            render: (record: RepayemtRemark) => (
                <span>{record.time && moment(record.time).format('DD/MM/YYYY HH:mm')}</span>
            ),
        },
        {
            title: 'Remarks',
            dataIndex: '',
            render: (record: RepayemtRemark) => <span>{record.comment}</span>,
        },
    ];

    return (
        <div>
            <MdOutlineMessage size="1.4rem" className="cursor-pointer" onClick={onClickRemark} />
            <Modal
                open={open}
                title="Repayment Remarks"
                footer={null}
                onCancel={onClickCancel}
                onOk={onClickCancel}
                centered
            >
                <div>
                    <Table
                        rowClassName={'table-row-dark'}
                        columns={columns}
                        dataSource={list || []}
                        className="w-full"
                        scroll={{ y: 400 }}
                        pagination={false}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default RemarksModal;
